export default __webpack_public_path__ + "static/media/Pistol_2.50f8cd8e.png";